/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Models_TitleInputs */

const en_nav_models_title = /** @type {(inputs: Nav_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Models`)
};

const es_nav_models_title = /** @type {(inputs: Nav_Models_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modelos`)
};

/**
* | output |
* | --- |
* | "Models" |
*
* @param {Nav_Models_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_models_title = /** @type {((inputs?: Nav_Models_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Models_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_models_title(inputs)
	return es_nav_models_title(inputs)
});